export class ManagementTokenPublishResult {
  token: string;
  tokenLifeSpan: number;
  conflictInformations: ManagementTokenInformation[];
}

export class ManagementTokenInformation {
  token: string;
  userName: string;
  editStartDateTime: Date;
  terminalName: string;
}
